import OrderTable from './modules/ProductTable/index.vue';
import TableData from './modules/TableData/index.vue';
export default {
  components: {
    // ConditionQuery,
    TableData,
    'v-ordertable': OrderTable
  },
  data() {
    return {
      personaldata: [],
      tablist: [{
        key: 0,
        value: '我的信息'
      }, {
        key: 1,
        value: '我的产品'
      }],
      loading: true,
      total: 0,
      activeKey: 0
    };
  },
  watch: {
    '$route.query': {
      handler(n) {
        if (n.tab === 'present') {
          this.activeKey = 1;
        } else {
          this.activeKey = 0;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    tabChange(val) {
      this.activeKey = val;
    },
    // 获取分页参数
    getPageOption(e) {
      Object.assign(this.searchOptions, e);
      this.getOrderList();
    }
  }
};